import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=04d84da0&scoped=true"
import script from "./SearchHeader.vue?vue&type=script&lang=js"
export * from "./SearchHeader.vue?vue&type=script&lang=js"
import style0 from "./SearchHeader.vue?vue&type=style&index=0&id=04d84da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d84da0",
  null
  
)

export default component.exports